import React from "react";

import { type BrandVideo } from "./types";

const PlayIcon: React.FC = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M8 5.5L18 12L8 18.5V5.5Z"
      fill="#ffffff"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

interface VideoThumbnailProps {
  video: BrandVideo;
}

/** 16:9 video thumbnail with a duration badge and a play icon revealed on hover. */
export const VideoThumbnail: React.FC<VideoThumbnailProps> = ({ video }) => (
  <div className="bg-fs-surface-secondary relative aspect-video w-full overflow-hidden rounded">
    <img
      src={video.thumbnail}
      alt={video.title}
      className="h-full w-full object-cover"
    />
    <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-150 ease-out group-hover:bg-(--slate-color-grey-1000)/10 group-hover:opacity-100">
      <span className="flex h-14 w-14 transform-gpu items-center justify-center rounded-full bg-(--slate-color-grey-1000)/35 pl-0.5 backdrop-blur-md [will-change:backdrop-filter]">
        <PlayIcon />
      </span>
    </div>
    <span className="type-fs-label text-fs-text-primary-inverse absolute right-2 bottom-2 rounded-[4px] bg-(--slate-color-grey-1000)/60 px-1.5 py-0.5">
      {video.duration}
    </span>
  </div>
);
